var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.classes,attrs:{"src":_vm.avatar,"alt":_vm.fullName}})}
var staticRenderFns = []

export { render, staticRenderFns }